import React from "react";
import CustomTags from "../../../Core/Components/CustomTags";
import TrikeIcon from "../../../Common/Svgs/TrikeIcon";
import HubStationIcon from "../../../Common/Svgs/HubStationIcon";
import { CONTAINER_STATUS } from "../data";

const getStatus = (status) => {
  switch (status) {
    case CONTAINER_STATUS.ON_A_TRIP:
      return (
        <CustomTags colors="onATrip" background="onATrip">
          <div className="flex items-center gap-x-2">
            <TrikeIcon size={16} className="stroke-yellow-dark fill-none" />
            <p>On A Trip</p>
          </div>
        </CustomTags>
      );

    case CONTAINER_STATUS.HUB_STATION:
      return (
        <CustomTags colors="hubStation" background="hubStation">
          <div className="flex items-center gap-x-2">
            <HubStationIcon className=" stroke-black fill-none" />
            <p>Hub Station</p>
          </div>
        </CustomTags>
      );

    default:
      return <div />;
  }
};

export default getStatus;
